import api from './api'

export interface CampoTemplate {
  id: string
  tipo: 'testo' | 'numero' | 'data' | 'ora' | 'checkbox' | 'select' |
        'foto' | 'firma' | 'textarea' | 'materiali' | 'separatore'
  etichetta: string
  obbligatorio: boolean
  ordine: number
  larghezza: 'full' | 'half'
  opzioni?: string[]
  scelte_multiple?: boolean
  max_foto?: number
  placeholder?: string
  note_admin?: string
}

export interface RapportinoTemplate {
  id: number
  nome: string
  descrizione?: string
  committente_id?: number | null
  committente_nome?: string | null
  campi: CampoTemplate[]
  versione: number
  attivo: boolean
}

export interface TemplateListItem {
  id: number
  nome: string
  committente_id?: number | null
  committente_nome?: string | null
  attivo: boolean
  versione: number
  num_campi: number
}

const BASE = '/rapportino-templates'

export const rapportinoTemplatesApi = {
  list: (params?: { attivo?: boolean; committente_id?: number }) =>
    api.get<TemplateListItem[]>(BASE, { params }).then(r => r.data),

  get: (id: number) =>
    api.get<RapportinoTemplate>(`${BASE}/${id}`).then(r => r.data),

  create: (payload: Omit<RapportinoTemplate, 'id' | 'versione'>) =>
    api.post<RapportinoTemplate>(BASE, payload).then(r => r.data),

  update: (id: number, payload: Omit<RapportinoTemplate, 'id' | 'versione'>) =>
    api.put<RapportinoTemplate>(`${BASE}/${id}`, payload).then(r => r.data),

  duplica: (id: number) =>
    api.post<RapportinoTemplate>(`${BASE}/${id}/duplica`).then(r => r.data),

  delete: (id: number) =>
    api.delete(`${BASE}/${id}`),

  getByWorkOrder: (workOrderId: number) =>
    api.get<RapportinoTemplate>(`${BASE}/by-work-order/${workOrderId}`).then(r => r.data),
}
